// extracted by mini-css-extract-plugin
module.exports = {"scrollToTop":"scrollToTop_scrollToTop__A9XNd","scrollToTopHidden":"scrollToTop_scrollToTopHidden__Dualf","icon":"scrollToTop_icon__SRO7T"};